// React Imports
import React from 'react';

// Mui Imports
import {Avatar, Tooltip} from '@mui/material';
import {GRID_DETAIL_PANEL_TOGGLE_FIELD} from "@mui/x-data-grid-pro";
import {deepOrange} from "@mui/material/colors";

// App Imports
import WorkIssuanceStatusMenu from "../Status/WorkIssuanceStatusMenu";
import WorkIssuanceStatusMenuDNU from "../WorkIssuanceStatusMenuDNU";


// main function
export const WorkIssuanceExpenseGridColumns = ({ hideActions,  handleMousedRow, cashState, accrualState, liabilityState, ultimatesState }) => [


    {
        field: 'id',
        headerName: 'id',
        description: '',
        sortable: true,
        editable: true,
        width: 60,
        hide: true
    },
    {
        field: 'contractName',
        headerName: 'On Contract',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        // editable: true,
        width: 350,
        hide: false
    },
    {
        field: 'reuseMarket',
        headerName: 'Reuse Market',
        description: '',
        sortable: false,
        editable: true,
        width: 300,

    },
    //
    {
        field: 'cdpId',
        headerName: 'cdpId',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },
    {
        field: 'dataPointId',
        headerName: 'dataPointId',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },
    {
        field: 'expenseAmount',
        headerName: 'raw expenseAmount',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        width: 80,
        hide: true
    },
    {
        field: 'displayExpenseAmount',
        headerName: cashState === true ? 'Cash Expense' :
            accrualState === true ? 'Accrual Expense':
                liabilityState === true ? 'Liability Expense':
                ultimatesState === true ? 'Ultimate Expense' : 'Expense',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        align: 'right', // aligns cell content
        headerAlign: 'right', // optional: aligns header text too
        width: 160,
        hide: false
    },
    {
        // field: 'mockIndicator',
        field: GRID_DETAIL_PANEL_TOGGLE_FIELD,
        type: 'actions',  // Required for built-in expand behavior
        headerName: 'Expression',
        renderCell: (contracts) =>
        {
            if((contracts.row.expression !== null) && (contracts.row.expression !== '')){
                return (
                    <Tooltip title={"Value comes from an expression.  Click to see."}>
                        <Avatar sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepOrange[500] }}>e</Avatar>
                    </Tooltip>)}
            // if(contracts.row.mockIndicator=='m'){
            //     return (
            //         <Avatar sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>{contracts.row.mockIndicator} </Avatar>)}
        },
        description: '',
        sortable: false,
        width: 90,

    },
    {
        field: "more",
        headerName: '',
        width: 20,
        padding: 0,
        margin: 0,
        sortable: false,
        menu: false,
        filter: false,
        hide: true,
        renderCell: (contracts) => {
            return (<div onMouseOver = {() => handleMousedRow(contracts.row)}  >
                    {/*// <MoreHorizIcon fontSize={'small'} onClick= {() => handleControls()}/>*/}
                    <WorkIssuanceStatusMenu/>
                </div>
            );
        }

    },
    // {
    //     field: 'status',
    //     // field: GRID_DETAIL_PANEL_TOGGLE_FIELD,
    //     headerName: 'Status',
    //     headerAlign: 'center',
    //     hide: cashState !== true,
    //     renderCell: (contracts) => {
    //         const rowCdpStatus = contracts.row.expenseStatus;
    //         return (<div onMouseOver={() => handleMousedRow(contracts.row)}
    //                      style={{
    //                          display: 'flex',
    //                          justifyContent: 'center',   // center horizontally
    //                          alignItems: 'center',       // center vertically
    //                          width: '100%',              // take full cell width
    //                          height: '100%',             // take full cell height
    //                      }}
    //             >
    //                 {/*// <MoreHorizIcon fontSize={'small'} onClick= {() => handleControls()}/>*/}
    //                 <WorkIssuanceStatusMenuDNU rowCdpStatus={rowCdpStatus}/>
    //             </div>
    //         );
    //     }
    // },
    {
        field: 'status',
        // field: GRID_DETAIL_PANEL_TOGGLE_FIELD,
        headerName: 'Status',
        headerAlign: 'center',
        hide: cashState !== true,
        renderCell: (contracts) => {
            const rowCdpStatus = contracts.row.expenseStatus;
            return (<div onMouseOver={() => handleMousedRow(contracts.row)}
                         style={{
                             display: 'flex',
                             justifyContent: 'center',   // center horizontally
                             alignItems: 'center',       // center vertically
                             width: '100%',              // take full cell width
                             height: '100%',             // take full cell height
                         }}
                >
                    {/*// <MoreHorizIcon fontSize={'small'} onClick= {() => handleControls()}/>*/}
                    <WorkIssuanceStatusMenu rowCdpStatus={rowCdpStatus}/>
                </div>
            );
        }
    },
    {    field: 'expenseStatus',
        headerName: 'expenseStatus',
        description: '',
        sortable: true,
        width: 60,
        hide: true
    },
    {    field: 'contractId',
        headerName: 'Contract ID',
        description: '',
        sortable: true,
        width: 60,
        hide: true
    },

    {
        field: 'displayPaymentAmount',
        headerName: cashState === true ? 'Cash Payment' :
            accrualState === true ? 'Accrual Payment':
                liabilityState === true ? 'Liability Payment':
                ultimatesState === true ? 'Ultimate Payment' : 'Payment',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        align: 'right', // aligns cell content
        headerAlign: 'right', // optional: aligns header text too
        // editable: true,
        width: 160,
        hide: false
    },
    {
        field: 'displayFringeAmount',
        headerName: cashState === true ? 'Cash Fringe' :
            accrualState === true ? 'Accrual Fringe':
                liabilityState === true ? 'Liability Fringe':
                ultimatesState === true ? 'Ultimate Fringe' : 'Fringe',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        align: 'right', // aligns cell content
        headerAlign: 'right', // optional: aligns header text too
        // editable: true,
        width: 160,
        hide: false
    },
    {
        field: 'displayTaxAmount',
        headerName: cashState === true ? 'Cash Tax' :
            accrualState === true ? 'Accrual Tax':
                liabilityState === true ? 'Liability Tax':
                ultimatesState === true ? 'Ultimate Tax' : 'Tax',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        align: 'right', // aligns cell content
        headerAlign: 'right', // optional: aligns header text too
        // editable: true,
        width: 160,
        hide: false
    },
    {
        field: 'dataType',
        headerName: 'dataType',
        description: '',
        sortable: false,
        editable: true,
        width: 100,
        hide: true
    },
    {
        field: 'sourceType',
        headerName: 'sourceType',
        description: '',
        sortable: false,
        editable: true,
        width: 100,
        hide: true
    },
    {
        field: 'dataPointRange',
        headerName: 'Range',
        description: '',
        sortable: false,
        editable: true,
        width: 80,
        hide: true
    },
    {
        field: 'cdpId',
        headerName: 'CDP ID',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },
    {
        field: 'cdpvId',
        headerName: 'CDPV ID',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },
    {
        field: 'iterationNumber',
        headerName: '#',
        description: '',
        sortable: false,
        editable: true,
        align: 'right', // aligns cell content
        headerAlign: 'right', // optional: aligns header text too
        width: 15,
        hide: true
    },
    {
        field: 'hierarchyLevel',
        headerName: 'hierarchyLevel',
        description: '',
        sortable: false,
        editable: true,
        width: 20,
        hide: true
    },
    {
        field: 'hierarchyOrder',
        headerName: 'hierarchyOrder',
        description: '',
        sortable: false,
        editable: true,
        width: 20,
        hide: true
    },
    {
        field: 'hierarchy',
        headerName: 'Hierarchy',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        width: 80,
        hide: true
    },

];
